import styled from 'styled-components';

export const StyledAnchor = styled.a`
  color: var(--text-color);
  font-size: var(--font--size-12);
  text-decoration: none;
  text-align: center;
`;
